import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    marginBottom: 8,
  },
  header: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  number: {
    width: 40,
    height: 40,
    padding: 4,
    borderRadius: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12,
  },
  numberLabel: {
    width: '100%',
    height: '100%',
    borderRadius: '100%',
    textAlign: 'center',
    verticalAlign: 'middle',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  status: {
    padding: '4px 8px',
    borderRadius: 20,
    display: 'inline-block',
    marginTop: 4,
  },
  statusLabel: {
    fontSize: '12px',
  },
  statusIcon: {
    color: 'white',
    width: 17,
    height: 'auto',
  },
  line: {
    width: 2,
    height: 112,
    marginTop: 8,
    borderRadius: 4,
    background: theme.palette.secondary.light,
    transform: 'translateX(calc((40px / 2) - 1px))',
  },
  lineInner: {
    width: '100%',
    borderRadius: 4,
  },
  completed: {
    '& $numberLabel': {
      backgroundColor: theme.palette.success.main,
      color: 'white',
    },
    '& $status': {
      background: theme.palette.success.light,
    },
    '& $statusLabel': {
      color: theme.palette.success.dark,
    },
    '& $lineInner': {
      height: '100%',
      background: theme.palette.success.main,
    },
  },
  inprogress: {
    '& $number': {
      border: `1px solid ${theme.palette.primary.main}`,
    },
    '& $numberLabel': {
      backgroundColor: theme.palette.primary.main,
      color: 'white',
    },
    '& $status': {
      background: theme.palette.primary.light,
    },
    '& $statusLabel': {
      color: theme.palette.primary.dark,
    },
    '& $lineInner': {
      height: '50%',
      background: theme.palette.primary.main,
    },
  },
  incomming: {
    '& $numberLabel': {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.secondary.dark,
    },
    '& $status': {
      background: theme.palette.secondary.light,
    },
    '& $statusLabel': {
      color: theme.palette.secondary.dark,
    },
  },
}))
